import Box from '@mui/material/Box';
import TipTapBarMenu from '../GridDndEditor/TiptapEditor/TipTapBarMenu';
import SectionsToggleButton from '../SectionsDrawer/SectionsToggleButton';
import { EditorUndoRedoToolbar } from './EditorUndoRedoToolbar';
import { useAppSelector } from 'components/editor/grid/reduxStore/Store';
import { selectContentType } from 'components/editor/grid/reduxStore/documentSettingsSlice';
import { ContentType } from 'utils/getContentType';

export function EditorToolbar() {
  const contentType = useAppSelector(selectContentType);

  return (
    <Box
      id="editor-toolbar-container"
      className={'editor-toolbar-container'}
      sx={{
        display: 'flex',
        justifyContent: 'left',
        alignItems: 'normal',
        width: '100%',
        height: '50px',
        borderTop: '1px solid #f0f0f0',
        borderRadius: '5px',
        borderBottom: '1px solid #f0f0f0',
        gap: '1rem',
      }}
    >
      <span style={{ visibility: contentType === ContentType.SECTION ? 'hidden' : 'visible', display: 'contents' }}>
        <SectionsToggleButton />
      </span>
      <Box
        sx={{
          flex: '1 1 auto',
          display: 'flex',
          flexWrap: 'nowrap',
          alignItems: 'center',
          paddingLeft: 0,
          minWidth: 0,
        }}
      >
        <EditorUndoRedoToolbar />
        <TipTapBarMenu />
      </Box>
    </Box>
  );
}
